import Cookies from 'js-cookie';


export const ASYNC_SIGNIN = "kopaproLicense/user/asyncSignIn";
export const SIGNIN_SUCCESS = "kopaproLicense/user/signInSuccess";
export const ASYNC_LOGOUT = "kopaproLicense/user/asyncLogout";
export const LOGOUT_SUCCESS = "kopaproLicense/user/logoutSuccess";
export const ASYNC_UPDATE_PASSWORD = "kopaproLicense/user/asyncUpdatePassword";

export const initialState = {   
    uuid: '',
    email: '',
    type: '',
    role: '',
    authorization: '',
    scopes: ''
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case SIGNIN_SUCCESS:
            if(payload){
                return {
                    ...state,                    
                    email: payload.email,
                    type: payload.type,
                    authorization: payload.authorization
                                   
                }
            }
        case LOGOUT_SUCCESS:
            return {
                uuid: '',
                email: '',
                type: '',
                role: '',
                authorization: 'invalid',
                scopes: ''
            }
    default:
        return {...state}
    }
}

export const asyncSignin = (email,password,callback) => ({
    type: ASYNC_SIGNIN, payload:{
        email: email,
        password: password,
        callback: callback
    }
})

export const asyncLogout = () => ({
    type: ASYNC_LOGOUT, payload:{}
})

export const loggoutSuccess = () => ({
    type: LOGOUT_SUCCESS
})

export const asyncUpdatePassword = (currentPassword, newPassword, callback) => ({
    type: ASYNC_UPDATE_PASSWORD, payload:{
        currentPassword,
        newPassword,
        callback
    }
})

export const signInSuccess = (userPayload) => ({
    type: SIGNIN_SUCCESS, payload:{
        ...userPayload
    }
})